import React from 'react';

import './App.css';
import './i18n'; // Importer la config i18n

import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Home from './containers/Home';
import AvaApp from './containers/AvaApp';
import AvaForm from './containers/AvaForm';
import AvaForms from './containers/AvaForms';
import SimulateurVolume from './containers/SimulateurVolume';
import Historique from './containers/Historique';

import AnalyseResume from './containers/AnalyseResume';
import AnalyseTraitement from './containers/AnalyseTraitement';
import AnalyseTraitementFamille from './containers/AnalyseTraitementFamille';
import AnalyseProduitsAll from './containers/AnalyseProduitsAll';
import AnalyseProduitDetail from './containers/AnalyseProduitDetail';
import Login from './containers/Login';
import Administration from './containers/admin/Administration';
import Spintouch from './containers/spintouch/Spintouch';




const App = () => (
  <BrowserRouter>
    <Routes>
      
      <Route path="/" element={<AvaApp />}>
        <Route index element={<Home />} />
        <Route path="forms" element={<AvaForms />}>
          <Route path=":formId" element={<AvaForm />} />
        </Route>
        <Route path="simulateur" element={<SimulateurVolume />}>
        </Route>
        <Route path="historique" element={<Historique />}>
        </Route>
        <Route path="analyse" element={<AnalyseResume />}>
        </Route>
        <Route path="analyseTraitement" element={<AnalyseTraitement />}>
        </Route>
        <Route path="analyseTraitementFamille" element={<AnalyseTraitementFamille />}>
        </Route>
        <Route path="analyseProduitsAll" element={<AnalyseProduitsAll />}>
        </Route>
        <Route path="produit" element={<AnalyseProduitDetail />}>
        </Route>
        <Route path="login" element={<Login />}>
        </Route>
        <Route path="administration" element={<Administration />}>
        </Route>
        <Route path="spintouch" element={<Spintouch />}>
        </Route>  

      </Route>
    </Routes>
  </BrowserRouter>
);

export default App;
